import { Component, Entity2D } from '../../../odie';
import { RainbowSoapBlockProps } from './RainbowSoapBlock';
import { RainbowSoapBlockView } from './RainbowSoapBlockView';

export type RainbowSoapBlockComponentOptions = {
  props: RainbowSoapBlockProps;
};

export class RainbowSoapBlockComponent implements Component {
  public static readonly NAME = 'blockRainbowSoap';

  public entity!: Entity2D;
  public view!: RainbowSoapBlockView;

  public init(args: RainbowSoapBlockComponentOptions): void {
    this.view = new RainbowSoapBlockView(args.props);
  }
}
